import errorLogoPNG from "../assets/img/error-logo.png";

export function MessageError(props) {
  const { message } = props;

  return (
    <div className="style-container-loading-page">
      <div className="d-flex flex-column align-items-center text-center">
        <img
          src={errorLogoPNG}
          alt="Apito"
          className="style-size-image-error-logo-page"
        />

        <div className="text-light style-fs-text-error-page d-flex justify-content-center">
          {message === null || message === undefined ? (
            <p className="">
              Busca sem resultados.
              <br />O usuário pode não existir
              <br />
              ou ter sido removido.
            </p>
          ) : (
            <p className="text-center" style={{ width: "80%" }}>
              {message}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
